import type { PollSettings, VotesData } from '../../types';
import { fillData } from '../utils';

type LocalUnvoteProps = {
  id: string;
  answers: PollSettings['answers'];
  data: VotesData | undefined;
};

export function unvoteLocal({
  id,
  answers,
  data: initialData
}: LocalUnvoteProps): VotesData {
  const data = fillData({
    answers,
    data: initialData
  });

  const total = data.total - 1;
  const votes = data.votes.map((vote) => {
    if (vote.id === id) {
      const count = vote.count - 1;

      return {
        id,
        count: count,
        percentage: total === 0 ? 0 : Math.round((count / total) * 100)
      };
    }

    return {
      ...vote,
      percentage: total === 0 ? 0 : Math.round((vote.count / total) * 100)
    };
  });

  return { total, votes };
}
